import API_CONFIG from "./api-config";
const BASE_PATH = API_CONFIG.API_ROOT;
const API_PATH = BASE_PATH + "safecv/api/v1/";

const API = {
  PROFILE: {
    DETAILS: API_CONFIG.API_ROOT + "profile",
    PREFERENCE: API_PATH + "profile/preferences",
    NOTIFICATIONS: API_PATH + "profile/notifications",
    ACCESS: (jobId) => {
      return API_PATH + jobId + "/access";
    },
    JWT: BASE_PATH + "jwt",
  },
  TOKEN: API_CONFIG.API_ROOT + "oauth/token",
  DOCUMENT_TYPES: API_PATH + "documenttypes",
  SUPPORT_DOC: API_PATH + "supportdoc",
  POSTACTION: {
    PLANS: API_PATH + "plans",
    UPLOADPROCESSPLAN: API_PATH + "plan",
    DISCIPLINE: API_PATH + "disciplines",
    GTPLAN: (jobId) => API_PATH + "plan/" + jobId + "?upload=gt",
  },
  ADDPLAN: {
    DISCIPLINE: API_PATH + "disciplines",
  },
  VERIFICATION: {
    VERIFIED: (jobId, status) => {
      return API_PATH + "plan/" + jobId + "/verify/" + status;
    },
    DISCIPLINEBYJOBID: (jobId) => {
      return API_PATH + "disciplines/plan/" + jobId;
    },
    DATES: (jobId) => {
      return API_PATH + "plan/" + jobId + "/details";
    },
    ANNOTATION: (jobId, type) => {
      return API_PATH + "plan/" + jobId + "/annotations?type=" + type;
    },
    ANNOTATIONSTATS: (jobId) => {
      return API_PATH + "plan/" + jobId + "/annotations/stats";
    },
    SEARCH: (jobId, keyword) => {
      return API_PATH + "plan/text/" + jobId + "/search?key=" + keyword;
    },
    ADDITIONAL_DOCUMENTS: (jobId) => {
      return API_PATH + "documents?jobId=" + jobId;
    },
    AUTOPOPULATE: (jobId, keyword) => {
      return (
        API_PATH +
        "plan/" +
        jobId +
        "/textsearch/autopopulate?keyword=" +
        keyword
      );
    },
  },
  DATATABLE_DOWNLOAD: API_PATH,
  PDF_DOWNLOAD: (jobId) => {
    return API_PATH + "plan/" + jobId + "/download/data";
  },
  PDF_DOWNLOADER: (url) => {
    return API_PATH + url;
  },
  FEEDBACK: {
    LIST: (jobId, type) => {
      return API_PATH + "feedback?jobid=" + jobId + "&type=" + type;
    },
    ADD: API_PATH + "feedback",
  },
  CRITERIA: API_PATH + "plan/criteria",
  PLAN_TYPE: API_PATH + "plantypes",
  CODEBOOK: API_PATH + "list/codebooks",
  STATES: API_PATH + "states?codebookenabled=true",
  JURISDICTION: API_PATH + "list/jurisdictions/state/",
  DISCARD_RESTORE: (jobId, annotationId, type) => {
    return (
      API_PATH +
      "plan/" +
      jobId +
      "/annotation/" +
      annotationId +
      "?type=" +
      type
    );
  },
  READ_ANNOTATION: (jobId, annotationId, type) => {
    return (
      API_PATH +
      "plan/" +
      jobId +
      "/annotations/" +
      annotationId +
      "/read?type=" +
      type
    );
  },
  RETRIGGERPLANS: API_PATH + "plan/retrigger/",
  ANNOTATION: {
    ADD: (jobId) => API_PATH + "plan/" + jobId + "/annotations",
    MODIFY: (jobId) => API_PATH + "plan/" + jobId + "/annotations",
    GETXFDF: (jobId) => API_PATH + "plan/" + jobId + "/annotations/xfdf",
    FULLXFDF: (jobId, outputType) =>
      API_PATH + "plan/" + jobId + "/xfdf?type=" + outputType,
  },
  DESIGN_CRITERIA: (jobId) => {
    return API_PATH + `designCriteria/${jobId}`;
  },
  STAMPS: {
    GETSTAMP: (jobId) => API_PATH + "stamps?jobId=" + jobId,
    UPDATESTAMPSTATUS: (jobId) => API_PATH + `plan/${jobId}/stamp`,
  },
  RECONCILIATION_REPORT: (jobId) => {
    return API_PATH + `plan/reconciliation/json/${jobId}`;
  },
  NEEDS_INPUT_RESPONSE: (jobId) => {
    return API_PATH + `plan/${jobId}/annotations/saveResponses`;
  },

  COMMENT_LETTER: {
    GET_COMMENT_LETTER: (jobId) => {
      return API_PATH + `commentletter/${jobId}`;
    },
    SAVE_COMMENT_LETTER: API_PATH + "commentletter",
    FETCH_SUGGESSTIONS: (searchText) => {
      return API_PATH + `autocomplete?searchText=${searchText}`;
    },
  },

  COMMENT_REPO: {
    GET_DISCIPLINES: () => {
      return API_PATH + `disciplines`;
    },
    GET_INITIAL_COMMENTS: (
      allChipFlag,
      allCommentSize,
      disciplineId,
      myCommentsSize,
      topCommentsSize
    ) => {
      if (allChipFlag) {
        return (
          API_PATH +
          "comments?allChipFlag=" +
          allChipFlag +
          "&allCommentSize=" +
          allCommentSize +
          "&myCommentsSize=" +
          myCommentsSize +
          "&topCommentsSize=" +
          topCommentsSize
        );
      } else {
        return (
          API_PATH +
          "comments?allChipFlag=" +
          allChipFlag +
          "&allCommentSize=" +
          allCommentSize +
          "&myCommentsSize=" +
          myCommentsSize +
          "&topCommentsSize=" +
          topCommentsSize +
          "&disciplineId=" +
          disciplineId
        );
      }
    },
    SEARCH_COMMENTS: (
      allChipFlag,
      allCommentSize,
      disciplineId,
      myCommentsSize,
      topCommentsSize,
      searchText
    ) => {
      if (allChipFlag) {
        return (
          API_PATH +
          "comments?allChipFlag=" +
          allChipFlag +
          "&allCommentSize=" +
          allCommentSize +
          "&myCommentsSize=" +
          myCommentsSize +
          "&topCommentsSize=" +
          topCommentsSize +
          "&searchText=" +
          searchText
        );
      } else {
        return (
          API_PATH +
          "comments?allChipFlag=" +
          allChipFlag +
          "&allCommentSize=" +
          allCommentSize +
          "&disciplineId=" +
          disciplineId +
          "&myCommentsSize=" +
          myCommentsSize +
          "&topCommentsSize=" +
          topCommentsSize +
          "&searchText=" +
          searchText
        );
      }
    },
    GET_MORE_COMMENTS: (
      allChipFlag,
      commentsSize,
      disciplineId,
      id,
      section
    ) => {
      if (allChipFlag) {
        return (
          API_PATH +
          "showmore?allChipFlag=" +
          allChipFlag +
          "&commentsSize=" +
          commentsSize +
          "&id=" +
          id +
          "&section=" +
          section
        );
      } else {
        return (
          API_PATH +
          "showmore?allChipFlag=" +
          allChipFlag +
          "&commentsSize=" +
          commentsSize +
          "&disciplineId=" +
          disciplineId +
          "&id=" +
          id +
          "&section=" +
          section
        );
      }
    },
    GET_MORE_COMMENTS_WITH_SEARCH: (
      allChipFlag,
      commentsSize,
      disciplineId,
      id,
      section,
      searchText
    ) => {
      if (allChipFlag) {
        return (
          API_PATH +
          "showmore?allChipFlag=" +
          allChipFlag +
          "&commentsSize=" +
          commentsSize +
          "&id=" +
          id +
          "&section=" +
          section +
          "&searchText=" +
          searchText
        );
      } else {
        return (
          API_PATH +
          "showmore?allChipFlag=" +
          allChipFlag +
          "&commentsSize=" +
          commentsSize +
          "&disciplineId=" +
          disciplineId +
          "&id=" +
          id +
          "&section=" +
          section +
          "&searchText=" +
          searchText
        );
      }
    },
  },
  ENHANCED_SEARCH: (jobId) => {
    return API_PATH + `plan/text/${jobId}/enhancedSearch`;
  },
  FAVOURITE_ANNOTATION: (jobId, annotationId) => {
    return API_PATH + `plan/${jobId}/annotations/${annotationId}/favourite`;
  },
  GET_FAVOURITE_ANNOTATIONS: (jobId) => {
    return API_PATH + `plan/${jobId}/annotations/favourite`;
  },
};

export default API;
